import { IReferral } from '@sales-center/common'
import * as React from 'react'
import { useHandlers } from './hooks'
import { StyledButton } from './styled/StyledButton.styled'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'

export type Props = {
  disabled: boolean
  onClick: () => void
  referral?: IReferral
  variant?: 'outlined' | 'contained' | 'text'
}

export function ReferralActionButton(props: Props) {
  const { disabled, referral, variant = 'outlined' } = props
  const referralHasValues =
    referral && (referral.referralValue || referral.referralType)
  const { handleClick } = useHandlers({
    ...props,
    formVariant: ReferralFormVariant.Drawer,
  })

  return referralHasValues ? (
    <StyledButton disableElevation onClick={handleClick} variant={variant}>
      Edit Referral
    </StyledButton>
  ) : (
    <>
      <StyledButton
        variant={variant}
        onClick={handleClick}
        disabled={disabled}
        data-test-id="addReferralBtn"
      >
        Add Referral
      </StyledButton>
    </>
  )
}
